var MONTH_NAME_SHORT = {
  en:[
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  es:[
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
  ]
}
var MONTH_NAME = {
  en:[
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  es:[
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octtubre",
  "Noviembre",
  "Diciembre",
  ]
}
var DAY_NAME = {
  en:[
    "Sunday",
    "Monday",
    "Tuesday",
    "Wedsday",
    "Thursday",
    "Friday",
    "Saturday",
    "Today",
    "Tomorrow",
  ],
  es:[
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Hoy",
    "Mañana",
  ]
}
var DAY_NAME_SHORT = {
  en:[
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Today",
    "Tomorrow",
  ],
  es:[
    "Dom",
    "Lun",
    "Mar",
    "Mié",
    "Jue",
    "Vie",
    "Sab",
    "Hoy",
    "Mañana",
  ]
}

function formatDate(year,month,day,lan="en") {
  var date = new Date(year,month,day);
  var today = new Date();
    if(date.getDate()===today.getDate() && date.getMonth()===today.getMonth() && date.getFullYear()===today.getFullYear()){
      return DAY_NAME_SHORT[lan][7];
    }
    var tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);
    if (date.getDate()===tomorrow.getDate() && date.getMonth()===tomorrow.getMonth() && date.getFullYear()===tomorrow.getFullYear()){
      return DAY_NAME_SHORT[lan][8];
    }

  return DAY_NAME_SHORT[lan][date.getDay()] +' '+ (day) + (month!==today.getMonth() ? ' '+MONTH_NAME_SHORT[lan][month] : '' )  + (date.getFullYear()!== (new Date()).getFullYear() ? ' '+year : '');
}

function formatTime(hour, minute) {
  return (hour === 0 ? '12' : (hour > 12 ? hour-12 : hour) ) + (minute===0?"":(':' + minute)) + (hour < 12 ? 'am' : 'pm');
}

function timePassedSince(date,lan='en') {
  var seccondsPassed = ((new Date()).getTime() - date.getTime())/1000;
  var str = "";
  var strPost = "";
  if(lan === 'en'){
    if(seccondsPassed<0){
      str="in "
      seccondsPassed = seccondsPassed*-1;
    }else{
      strPost=" ago";
    }
  }else if (lan === 'es'){
    if(seccondsPassed<0){
      str="en "
      seccondsPassed = seccondsPassed*-1;
    }else{
      str="hace "
    }
  }
  var minutes = seccondsPassed / 60;
  if(minutes<1){
    return str + seccondsPassed.toFixed(0) + "s" + strPost
  }

  var hours = seccondsPassed / (60*60);
  if(hours<1){
    return str + minutes.toFixed(0) + "m" + strPost
  }

  var days = seccondsPassed / (60*60*24);
  if(days<1){
    return str + hours.toFixed(0) + "h" + strPost
  }

  var weeks = seccondsPassed / (60*60*24*7);
  if(weeks<1){
    return str + days.toFixed(0) + "d" + strPost
  }

  var months = seccondsPassed / (60*60*24*30);
  if(months<1){
    return str + weeks.toFixed(0) + "w" + strPost
  }

  var years = seccondsPassed / (60*60*24*365);
  if(years<1){
    return str + months.toFixed(0) + "M" + strPost
  }
  return str + years.toFixed(0) + "M" + strPost
}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}


exports.formatDate = formatDate;
exports.formatTime = formatTime;
exports.timePassedSince = timePassedSince;
exports.validateEmail = validateEmail;
exports.MONTH_NAME_SHORT = MONTH_NAME_SHORT;
exports.MONTH_NAME = MONTH_NAME;
exports.DAY_NAME = DAY_NAME;
exports.DAY_NAME_SHORT = DAY_NAME_SHORT;


// WEBPACK FOOTER //
// ./src/utils/lib.js